const REDUCER_ACTIONS = Object.freeze({
    sharePromotionCode: {
        initial: "initial",
        sendClicked: "sendClicked",
        sendingEmail: "sendingEmail",
        emailSent: "emailSent",
        emailFailed: "emailFailed",
    },
});

const REDUCER_STATES = Object.freeze({
    sharePromotionCode: {
        initial: "initial",
        sendClicked: "sendClicked",
        sendingEmail: "sendingEmail",
        emailSent: "emailSent",
        emailFailed: "emailFailed",
    },
});

export { REDUCER_ACTIONS, REDUCER_STATES };
